import React from 'react';
import { IconType } from 'react-icons/lib';

import './style.scss';

type NoDataComponentProps = {
  Icon: IconType;
  title: string;
  description?: string;
  className?: string;
};

const NoDataComponent: React.FunctionComponent<NoDataComponentProps> = ({ Icon, title, description, className }) => {
  return (
    <div className={`no-data-container d-flex justify-content-center align-items-center ${className || ''}`}>
      <div className="content d-flex flex-column align-items-center text-center">
        <div className="rounded-circle d-flex justify-content-center align-items-center">
          <span>
            <Icon size="2rem" />
          </span>
        </div>
        <strong className="my-3">{title}</strong>
        <small className="text-muted">{description}</small>
      </div>
    </div>
  );
};

export default NoDataComponent;
